export default __webpack_public_path__ + "static/media/bnb-om.ce4ffb23.svg";